export default __webpack_public_path__ + "static/media/shareHome-logo.f13f02c8.webp";